export var refinanceTypes = ['refinance', 'cashout', 'equity'];
export var LanguageType;
(function (LanguageType) {
    LanguageType[LanguageType["English"] = 0] = "English";
    LanguageType[LanguageType["Spanish"] = 1] = "Spanish";
})(LanguageType || (LanguageType = {}));
